import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux'
import { Action } from 'redux'
import { actions } from '@opallabs/wormhole'
import { State } from '@opallabs/wormhole/types'
import { DispatchProps, OwnProps, StateProps } from './types'
import { PersonalPanel } from '.'

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (
  state
) => ({
  status: state.status || null,
  user: state.me || null,
})

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  getStatus: (): Action => dispatch(actions.getStatus()),
  onNotificationClick: (notification): void => {
    ownProps.notificationClickCallback(notification)
    dispatch(
      actions.updateNotification({
        ...notification,
        read: true,
        is_visible: true,
      })
    )
  },
  togglePersonalPanel: (isOpen): void => {
    dispatch(actions.togglePersonalPanel(isOpen))
  },
})

export const ConnectedPersonalPanel = connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonalPanel)
